import getAsyncStatusKeyPath from 'shared/utils/getAsyncStatusKeyPath';

export const baseKeyPath = ['findCustomer'];

/**
 * Generate the Relationship Cart keypath
 * If requestKey is unspecified, the returned keyPath refers to all requests for the specified asyncId
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 * @param {string?} requestKey identifier used to classify the type of request
 * @param {string?} instanceId identifier used to store an intance of a request (for simultaneous requests of the same type)
 * @returns {Array} Array of strings [...baseKeyPath, asyncId {, requestKey {, instanceId}}]
 */
const keyPath = (asyncId, requestKey = null, instanceId = null) =>
	getAsyncStatusKeyPath(asyncId, baseKeyPath, requestKey, instanceId);

/**
 * Generate the Find Customer keypath
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 * @returns {function} Wrapped keyPath with requestKey set to 'findCustomer'
 */

export const makeFindCustomerKeyPath = asyncId => keyPath(asyncId, 'findCustomer');

/**
 * Generate the Zip Code Verification keypath
 * @param {string} asyncId UUID used to group requests issued by a particular feature
 * @returns {function} Wrapped keyPath with requestKey set to 'zipVerification'
 */
export const makeZipVerificationKeyPath = (asyncId, zipCodeFieldPath = null) =>
	keyPath(asyncId, 'zipVerification', zipCodeFieldPath);

export default keyPath;
